"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactPlayable_1 = require("./components/ReactPlayable");
exports.ReactPlayable = ReactPlayable_1.ReactPlayable;
exports.default = ReactPlayable_1.ReactPlayable;
//# sourceMappingURL=index.js.map